import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Form, Formik } from "formik";

import useGroupService from "../../services/api/groupService";
// import useCampaignService from "../../services/api/campaignService";

import { Button, IconButton, Loading } from "../../components";
import { TextInput } from "../forms";
import { PlusCircleIcon, SearchIcon, PinIcon } from "../../assets/icons";
import "./NotificationTabs.scss";
import { toast } from "react-toastify";
import { enums } from "../../constants/enum";

export default function GroupListTab({ onSelectGroup, disabled = false }) {
  const [search, setSearch] = useState("");
  const { getAllGroups, queryKey: groupQueryKey } = useGroupService();
  // const { getCampaigns, queryKey: campaignQueryKey } = useCampaignService();
  // const { ref, inView } = useInView();

  const {
    data: groupData,
    isLoading: isGroupLoading,
    isError: isGroupError,
    error: groupError,
  } = useQuery({
    queryKey: [groupQueryKey, search],
    queryFn: () => getAllGroups(search),
    enabled: true,
  });

  /*
  const {
    data: campaignsData,
    isLoading: isCampaignsLoading,
    isError: isCampaignsError,
    error: campaignsError,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: [campaignQueryKey, "pagination", search],
    queryFn: ({ pageParam = 1 }) => getCampaigns(search, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage?.totalPages > lastPage?.currentPage) {
        return lastPage?.currentPage + 1;
      }
      return undefined;
    },
  });

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);
  
    if (isCampaignsError) {
      toast.error(
        campaignsError.response.data.payload.message ||
          enums.DEFAULT_ERROR_MESSAGE,
      );
    }

  */

  const { groups } = groupData || {};
  if (isGroupError) {
    toast.error(
      groupError.response.data.payload.message || enums.DEFAULT_ERROR_MESSAGE,
    );
  }

  const handleSelectGroup = (
    selectedGroup = "",
    customerIds = [],
    groupId = null,
    // campaignId = null,
  ) => {
    if (disabled) {
      toast.error("Please remove customers before selecting a group");
      return;
    }
    if (Object.values(enums.VIRTUAL_GROUPS).includes(selectedGroup)) {
      onSelectGroup({selectedGroup, customerIds});
      return;
    } else if (groupId) {
      onSelectGroup({selectedGroup, groupId});
      return;
    }
  };

  return (
    <div className="contact-list-container">
      <div className="search-bar">
        <Formik
          initialValues={{ searchGroup: "" }}
          onSubmit={(values) => setSearch(values.searchGroup)}
        >
          <Form>
            <TextInput
              name="searchGroup"
              placeholder="Enter group or campaign name"
              className="search-input"
            />
            <IconButton
              type="submit"
              icon={<SearchIcon className="search-icon" />}
            />
          </Form>
        </Formik>
      </div>

      <div className="contact-list groups-list">
        <div className="table-content">
          <table>
            <tbody>
              {/* Pinned Groups */}

              <tr className="section-header-row">
                <td colSpan="2" className="section-header">
                  Pinned Groups
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" /> {"All Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.ALL_CUSTOMERS,
                        groups?.virtual?.allCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" />{" "}
                    {"All Eye Campaign Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.ALL_EYE_CAMP_CUSTOMERS,
                        groups?.virtual?.allEyeCampCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" /> {"All Shop Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.ALL_SHOP_CUSTOMERS,
                        groups?.virtual?.allShopCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" /> {"Last Day Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.LAST_DAY_CUSTOMERS,
                        groups?.virtual?.lastDayCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" /> {"Last Week Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.LAST_WEEK_CUSTOMERS,
                        groups?.virtual?.lastWeekCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div className="group-name-cell">
                    <PinIcon className="pin-icon" /> {"Last Month Customers"}
                  </div>
                </td>
                <td>
                  <Button
                    text="Select"
                    icon={<PlusCircleIcon />}
                    onClick={() =>
                      handleSelectGroup(
                        enums.VIRTUAL_GROUPS.LAST_MONTH_CUSTOMERS,
                        groups?.virtual?.lastMonthCustomers,
                      )
                    }
                    className="action-btn"
                  />
                </td>
              </tr>

              {/* Custom Groups */}

              <tr className="section-header-row">
                <td colSpan="2" className="section-header">
                  Custom Groups
                </td>
              </tr>
              {groups?.userDefined?.customerGroups?.map((grp) => (
                <tr key={grp._id}>
                  <td>{grp.name}</td>
                  <td>
                    <Button
                      text="Select"
                      icon={<PlusCircleIcon />}
                      onClick={() => handleSelectGroup(grp.name, [], grp._id)}
                      className="action-btn"
                    />
                  </td>
                </tr>
              ))}

              {/* Campaigns */}
              {/* 
              <tr className="section-header-row">
                <td colSpan="2" className="section-header">
                  Campaigns
                </td>
              </tr>
              {campaignsData?.pages
                .flatMap((page) => page.campaigns)
                .map((campaign) => (
                  <tr key={campaign._id}>
                    <td>{campaign.name}</td>
                    <td>
                      <Button
                        text="Select"
                        icon={<PlusCircleIcon />}
                        onClick={() => handleSelectGroup([],campaign._id)}
                        className="action-btn"
                      />
                    </td>
                  </tr>
                ))}  */}
            </tbody>
          </table>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px 0",
            }}
            ref={ref}
          >
            {isFetchingNextPage ? <Loading variant="inline" /> : null}
          </div> */}
        </div>
      </div>
      <Loading variant="overlay" isLoading={isGroupLoading} />
    </div>
  );
}
